import { useEffect, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from '../forms/useForm';
import { usePagination } from '../pagination/usePagination';
import { sendRequest } from '../requests/useRequest';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { validarSesion } from '../tokens/useToken';

export const useAntibiotic = () => {

    const history = useHistory();

    const [antibiotics, setAntibiotics] = useState([]);
    const [antibioticId, setAntibioticId] = useState(0);

    const [method, setMethod] = useState("");
    const [modal, setModal] = useState(false);
    const [modalTitle, setModalTitle] = useState("");

    const [loading, setLoading] = useState(false);
    const [createSweet] = useSweetAlert();
    const [modalAlert, setModalAlert] = useState(false);
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);
    const [searchAntibiotic, setSearchAntibiotic] = useState("");
    const [loadingExport, setLoadingExport] = useState(false);

    const [formValues, handleInputChange, reset, handleUpdateValues] = useForm({
        antibiotic: "",
        aware: "",
    });

    const { antibiotic, aware } = formValues;

    useEffect(() => {
        getAntibiotics();
    }, []);

   
    const [validaciones, setValidaciones] = useState({
        antibiotic_valid: false,
    });

    const getAntibiotics = async () => {
        let requestOptions = {
            method: 'GET'
        };

        const respuesta = await sendRequest(requestOptions, "Antibiotic/List");

        if (respuesta.code === 200) {
            let listAntibiotics = [];
            let startItems = 0;
            let endItems = numberItems;
            let aux = numberItems * currentPage;

            endItems = aux;

            startItems = endItems - numberItems;
            if (respuesta.data.length >= 1) {
                respuesta.data.forEach((data, index) => {

                    let posicion = index + 1;
                    let visibleTable = false;
                    
                    if (posicion > startItems && posicion <= endItems) {
                        visibleTable = true;
                    }
    
                    listAntibiotics.push({
                        id_mic_antibiotic: data.id_mic_antibiotic,
                        id_mic_antibiotic_group: data.id_mic_antibiotic_group,
                        antibiotic: data.antibiotic,
                        aware: data.aware,
                        visibleTable: visibleTable
                    });
                });
                setAntibiotics(listAntibiotics);
                setAntibioticsData(listAntibiotics);
            }
            else {
                setAntibiotics([]);
            }
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, getAntibiotics);
        }
        else if (respuesta.code === 500) {
            createSweet("error", "error", "Antibioticos", "Ocurrio un problema en el servidor");
        }
        else {
            createSweet("error", "warning", "Antibioticos", respuesta.data.msg);
        }
    }

    // const toggle = () => {
    //     setModal(!modal);
    // }

    const openDialog = (title, mode) => {
        setModalTitle(title);
        setMethod(mode);
        setModal(true);
    };

    const closeDialog = () => {
        setModal(false);
    };

    const openDeleteAlert = () => {
        setShowDeleteAlert(true); 
        setModalAlert(true);  
    };

    const closeDeleteAlert = () => {
        setModalAlert(false);   
    };

    const handleCreate = () => {
        handleUpdateValues({
            antibiotic: "",
            id_mic_antibiotic_group: "",
            aware: "",
        });

        setValidaciones({
            antibiotic_valid: false,
            id_mic_antibiotic_group_valid: false,
        });

        setAntibioticId(0);
        setMethod("create");
        setModalTitle("Crear antibiotico");
        openDialog("Crear Antibioticos", "create");
    }

    const saveCreate = async (e) => {
        e.preventDefault();

        setLoading(true);

        if (validarForm()) {
            setLoading(false);
            return;
        }

        let mValues = JSON.stringify(formValues);

        let requestOptions = {
            method: 'POST',
            body: mValues
        };

        const respuesta = await sendRequest(requestOptions, "Antibiotic");

        if (respuesta.code === 200) {
            getAntibiotics();
            reset();
            createSweet("create", "success", "Exito!", "Antibiotico creado con exito");
            setLoading(false);
            closeDialog();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveCreate);
            setLoading(false);
        }
        else if (respuesta.code === 500) {
            createSweet("error", "error", "Antibioticos", "Ocurrio un problema en el servidor");
            setLoading(false);
        }
        else {
            createSweet("error", "warning", "Antibioticos", respuesta.data.msg);
            setLoading(false)
        }
        // else {
        //     setLoading(false);
        //     validarSesion(history, respuesta.code, saveCreate);
        // }
    }

    const handleUpdate = (id_antibiotic) => {
        let antibiotic = antibiotics.find(s => s.id_mic_antibiotic === parseInt(id_antibiotic));

        handleUpdateValues({
            antibiotic: antibiotic.antibiotic,
            id_mic_antibiotic_group: antibiotic.id_mic_antibiotic_group,
            aware: antibiotic.aware
        });

        setValidaciones({
            antibiotic_valid: false,
            id_mic_antibiotic_group_valid: false,
        });

        setAntibioticId(id_antibiotic);
        setMethod("update");
        setModalTitle("Actualización de antibiotico");
        openDialog("Editar Antibioticos", "update");
    }

    const saveUpdate = async (e) => {
        e.preventDefault();

        let body = {
            id_mic_antibiotic: antibioticId,
            ...{ ...formValues }
        };

        let mValues = JSON.stringify(body);

        let requestOptions = {
            method: 'PUT',
            body: mValues
        };

        const respuesta = await sendRequest(requestOptions, "Antibiotic/Update");

        if (respuesta.code === 200) {
            getAntibiotics();
            createSweet("create", "success", "Exito!", "Antibiotico actualizada");
            setLoading(false);
            closeDialog();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveUpdate);
            setLoading(false);
        }
        else if (respuesta.code === 500) {
            createSweet("error", "error", "Antibioticos", "Ocurrio un problema en el servidor");
            setLoading(false);
        }
        else {
            createSweet("error", "warning", "Antibioticos", respuesta.data.msg);
            setLoading(false)
        }
        // else {
        //     setLoading(false);
        //     validarSesion(history, respuesta.code, saveUpdate);
        // }
    }

    const handleDelete = (id_antibiotic) => {
        let antibiotic = antibiotics.find(s => s.id_mic_antibiotic === id_antibiotic);

        handleUpdateValues({
            antibiotic: antibiotic.antibiotic,
            id_mic_antibiotic_group: antibiotic.id_mic_antibiotic_group,
        });

        setAntibioticId(id_antibiotic);
        setMethod("delete");
        setModalTitle("Eliminar antibiotico");
        setShowDeleteAlert(true);
        setModalAlert(true);    
    }


    const saveDelete = async (e) => {
        e.preventDefault();

        let requestOptions = {
            method: 'DELETE'
        };

        const respuesta = await sendRequest(requestOptions, `Antibiotic/${antibioticId}`);
        ////console.log(respuesta);
        if (respuesta.code === 200) {
            getAntibiotics();
            setLoading(false);
            createSweet("create", "info", "Exito!", "Antibiotico eliminada");
            setModalAlert(false);
            setShowDeleteAlert(false);
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveDelete);
            setLoading(false);
        }
        else if (respuesta.code === 500) {
            createSweet("error", "error", "Antibioticos", "Ocurrio un problema en el servidor");
            setLoading(false);
        }
        else {
            createSweet("error", "warning", "Antibioticos", respuesta.data.msg);
            setLoading(false)
        }
        // else {
        //     setLoading(false);
        //     validarSesion(history, respuesta.code, saveDelete);
        // }

    }

    const validarForm = () => {
        let statusValidation = false;
        let newValidations = {};
        // antibiotic, gram, id_mic_antibiotic
        if (formValues.antibiotic === undefined || formValues.antibiotic.length < 1) {
            newValidations = {
                ...newValidations,
                antibiotic_valid: true
            };
            statusValidation = true;
        }
        else {
            newValidations = {
                ...newValidations,
                antibiotic_valid: false
            }
        }

        setValidaciones(newValidations);

        return statusValidation;
    }

    const numberItems = 10;
    const { totalPageCount, currentPage, nextPage, previousPage, goToPage } = usePagination(antibiotics.length, numberItems);

    useEffect(() => {
        let startItems = 0;
        let endItems = numberItems;

        let aux = numberItems * currentPage;

        endItems = aux;

        startItems = endItems - numberItems;
        let listAntibiotics = [];
        antibiotics.forEach((data, key) => {

            let posicion = key + 1;
            let visibleTable = false;

            if (posicion > startItems && posicion <= endItems) {
                visibleTable = true;
            }

            listAntibiotics.push({
                ...data,
                visibleTable: visibleTable
            });
        });

        setAntibiotics(listAntibiotics);
    }, [totalPageCount, currentPage])


    const [antibioticsData, setAntibioticsData] = useState([]);
    const handleSearch = (e) => {
        setSearchAntibiotic(e);

        let busqueda = e.toUpperCase();
        let newAntibiotic = [];

        antibioticsData.forEach(element => {

            let cadena = element.antibiotic.toUpperCase();
            if (cadena.indexOf(busqueda.toUpperCase()) > -1) {
                element.visibleTable = true;
                newAntibiotic.push(element);
            }
        });
        setAntibiotics(newAntibiotic);
    }
        const handleClearAntibiotic = () => {
        setSearchAntibiotic("");                         
        localStorage.removeItem("globalFilter");    
        setAntibiotics(antibioticsData);                    
    };


    const handleExportExcelMorphology = async () => {
        setLoadingExport(true);

        try {
            const XLSX = await import("xlsx");

            const _report = antibiotics.map((item, index) => ({
                "#": index + 1, 
                Antibioticos: item.antibiotic ?? "---",
            }));

            const worksheet = XLSX.utils.json_to_sheet(_report);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Antibióticos");

            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

            const dataBlob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "catalogo_antibióticos.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Error al exportar Excel", error);
        }

        setLoadingExport(false);
    };


    return {
        antibiotics, method, validaciones,
        antibiotic,
        handleInputChange, loading,
        closeDialog, modal, modalTitle,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        nextPage, previousPage, goToPage, totalPageCount, currentPage, handleSearch,
        showDeleteAlert, modalAlert,
        closeDeleteAlert, openDeleteAlert,
        handleExportExcelMorphology, loadingExport, handleClearAntibiotic,searchAntibiotic, aware
    }

}
